import * as React from 'react';
import { StyledGlobal } from './components/Styled';

import DefaultErrorBoundary from './components/DefaultErrorBoundary';
import { Routes } from './components/Routes';
import { useDynatraceScript } from './hooks/useDynatraceScript';
import { AuthProvider } from './contexts/authContext';

const App = (): React.ReactElement => {
  useDynatraceScript();

  return (
    <div>
      <React.StrictMode>
        <DefaultErrorBoundary>
          <main>
            <AuthProvider>
              <StyledGlobal />
              <Routes />
            </AuthProvider>
          </main>
        </DefaultErrorBoundary>
      </React.StrictMode>
    </div>
  );
};
export default App;
